export { CampaignElementWrapper } from './CampaignElementWrapper';



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignElementWrapper/index.js